const tripReports = {
  tripsPaxReports: {
    tripId: 'מזהה נסיעה',
    date: 'תאריך',
    status: 'סטטוס',
    statuses: 'סטטוסים',
    drivers: 'נהגים',
    vehicles: 'רכבים',
    from: 'מ-',
    to: 'אל',
    passengers: 'נוסעים',
    statusDone: 'בוצע',
    statusNew: 'חדש',
    statusCanceled: 'בוטל',
    statusInRoute: 'בנסיעה',
    average: 'ממוצע',
    trips: 'נסיעות',
    tripsPassengersSummary: 'סיכום נסיעות/נוסעים',
  },
};

export default tripReports;
